module.exports = __webpack_public_path__ + "static/media/onda-violeta.c118c1db.png";